export default __webpack_public_path__ + "static/prof_mobile-cf4ec0e85095d21a7cedb3416ed8766a.png";